import axios from 'axios';
import { API_BASE_URL, config } from '../constants/api';
export const fetchAudioLogs = async () => {
  const res = await axios.get(`${API_BASE_URL}/media/get-all-audio-logs`,config);
  return res.data;
};
export const fetchVideoLogs = async () => {
  const res = await axios.get(`${API_BASE_URL}/media/get-all-video-logs`,config);
  return res.data;
};